// extracted by mini-css-extract-plugin
export default {"a":"Anchor_a__Mrm7W","primary":"Anchor_primary__ur71Q","secondary":"Anchor_secondary__oRSHF","tertiary":"Anchor_tertiary__9j6+X"};